import { camelCase } from 'lodash'
import type { IEntityDataItem } from '~/types/models'

export async function propagateFlagChangeAfterDelete({
  callingMn,
  sourceEntityFlagPropertyName,
  sourceEntityData,
  targetEntity,
  finallyFn = () => {},
}: {
  callingMn: string
  sourceEntityFlagPropertyName: string
  sourceEntityData: Partial<IEntityDataItem>
  targetEntity: IEntityDataItem
  finallyFn?: Function
}): Promise<boolean> {
  const fn =
    `${callingMn} --> [cynqueModules/propagateFlagChangeAfterDelete] |` +
    ` ${propagateFlagChangeAfterDelete.name}`
  if (!sourceEntityData.hasOwnProperty(sourceEntityFlagPropertyName)) {
    console.debug(`${fn} does NOT include ${sourceEntityFlagPropertyName}`)
    return false
  }
  console.debug(
    `${fn} includes ${sourceEntityFlagPropertyName} (${sourceEntityData[sourceEntityFlagPropertyName]})`
  )
  if (!sourceEntityData[sourceEntityFlagPropertyName] === true) {
    console.debug(
      `${fn} ${sourceEntityFlagPropertyName} in source entity is false.` +
        ` No further action necessary for this property.`
    )
    return false
  }
  // reassign targetProperty based on change
  const targetPropertyName = camelCase(
    sourceEntityFlagPropertyName.replace('is', '')
  )
  targetEntity[targetPropertyName] = undefined
  console.debug(
    `${fn} target entity after reassigment to undefined:`,
    targetEntity
  )
  await finallyFn()
  return true
}
